export default __webpack_public_path__ + "static/media/ic_chart.0be54717.svg";